import React from 'react';
import classNames from 'classnames';
import { mapCursorToMax } from 'map-cursor-to-max';
import './Crossfader.scss';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  cursor: number;
};

export const Crossfader: React.FC<Props> = ({ children, className, cursor = 0, ...rest }) => {
  const frames = React.Children.toArray(children);

  const [currentIndex, nextIndex] = [
    mapCursorToMax(cursor, frames.length),
    mapCursorToMax(cursor + 1, frames.length)
  ];

  return (
    <div className={classNames('Crossfader', className)} {...rest}>
      <div className="Crossfader__next">{frames[nextIndex]}</div>
      <div className="Crossfader__current">{frames[currentIndex]}</div>
    </div>
  );
};
